import { useConfigService } from '@thd-nucleus/experience-context';
import { getBrandName, getBundleImage, getUpdatedProducts } from '../utils/product-utils';
import { useDataProducts } from './useDataProducts';

export const useBundleProducts = ({ bundle }) => {
  const bundleComponents = bundle?.bundleSpecificationDetails?.components;
  const configBundleProductsDetails = useConfigService('bundleProductsDetails') || null;
  const { data, loading, error } = useDataProducts({
    itemIds: bundleComponents?.map(({ defaultProductId }) => defaultProductId),
    skip: !bundleComponents || bundleComponents.length === 0
  });
  const brand = getBrandName(bundle, data?.products);
  const image = getBundleImage(bundle);

  return {
    productsData: getUpdatedProducts(data?.products, bundleComponents, configBundleProductsDetails),
    error,
    loading,
    brand,
    image
  };
};
